/**
 * Governed library source blob open URL helpers (presentation-only).
 */

import { buildGovernedPdfBlobOpenHash } from "./cognitoryGovernedPdfPassageHighlight";

export function buildGovernedLibrarySourceBlobOpenUrl(input: {
  blob: Blob;
  contentType: string;
  pageNumber?: number | null;
  /** Verified literal passage for optional native PDF text-directive highlight. */
  citedPassage?: string | null;
}): string {
  const typedBlob =
    input.blob.type === input.contentType
      ? input.blob
      : new Blob([input.blob], { type: input.contentType });
  const blobUrl = URL.createObjectURL(typedBlob);
  const hash = buildGovernedPdfBlobOpenHash({
    contentType: input.contentType,
    ...(input.pageNumber !== undefined ? { pageNumber: input.pageNumber } : {}),
    ...(input.citedPassage !== undefined
      ? { citedPassage: input.citedPassage }
      : {}),
  });
  return hash ? `${blobUrl}${hash}` : blobUrl;
}

export function openGovernedLibrarySourceBlob(input: {
  blob: Blob;
  contentType: string;
  pageNumber?: number | null;
  citedPassage?: string | null;
}): void {
  const openUrl = buildGovernedLibrarySourceBlobOpenUrl(input);
  const opened = window.open(openUrl, "_blank", "noopener,noreferrer");
  if (!opened) {
    URL.revokeObjectURL(openUrl.split("#")[0] ?? openUrl);
    return;
  }
  window.setTimeout(() => {
    URL.revokeObjectURL(openUrl.split("#")[0] ?? openUrl);
  }, 60_000);
}
